import React from "react";
import clsx from "clsx";
import Container from "./../../views/Container";

import styles from "./InfoboxCombo.styles";

const InfoboxCombo = props => {
	const css = styles();

	return (
		<Container className={clsx(css.combo, "extension-infobox-combo")}>
			<div>{props.children}</div>
		</Container>
	);
};

export default InfoboxCombo;
